import { useMemo } from "react"
import { TableVisualization } from "~/ui-rtk/components/ui/charts"
import ChartLoader from "~/ui-rtk/components/ui/charts/ChartLoader"
import TableFiltersBar from "~/ui-rtk/components/ui/controls/FiltersBar/TableFiltersBar"
import {
  AggregationType,
  VISUALIZATION_TYPE,
  VISUALIZATIONS_MAP,
  type VISUALIZATIONS_MAP_KEY,
} from "~/ui-rtk/constants/charts"
import useSources from "~/ui-rtk/hooks/sources"

export const TABLE_WIDGETS = {
  PLATFORM: "brand_value_conversions_by_platform_table",
  CHANNEL: "brand_value_conversions_by_channel_table",
  CHANNEL_GROUP: "brand_value_conversions_by_channel_group_table",
}

export default function BrandValueOverviewTable({
  granularity,
  dateRange,
  compareRange,
  cubeQueryParams,
  widget,
}: {
  granularity: AggregationType
  dateRange: [Date, Date]
  compareRange?: [Date, Date]
  cubeQueryParams?: Record<string, string | string[]>
  widget: VISUALIZATIONS_MAP_KEY
}) {
  const { sources } = useSources()
  const visualization = useMemo(() => VISUALIZATIONS_MAP[widget], [widget])

  return (
    <div>
      <TableFiltersBar
        id={widget}
        className="h-12"
        columnConfig={visualization.props?.columnConfig}
        additionalFilters={visualization.props?.additionalFilters}
      />
      <div className="mt-system-lg">
        <ChartLoader
          {...visualization.props}
          chartId={widget}
          widgetType={VISUALIZATION_TYPE.TableVisualization}
          component={TableVisualization}
          dateRange={dateRange}
          compareRange={compareRange ?? undefined}
          granularity={granularity}
          sources={sources}
          hideAggSelector={true}
          requiredSources={visualization.requiredSources}
          cubeQueryParams={{
            [widget]: {
              ...cubeQueryParams,
              granularity,
            },
          }}
          description={visualization.description ?? undefined}
          compareMode={
            visualization.props?.comparisonEnabled &&
            (compareRange?.length ?? 0) > 0
          }
        />
      </div>
    </div>
  )
}
